import { Button } from '@fourthwall/components';
import { ApparelIcon, ButtonIcon, DocumentDownloadIcon, MoneyIcon, ProfileIcon, TagIcon, } from '@fourthwall/icons';
import React from 'react';
import { SubscriptionPerk } from '../../../../components/SubscriptionPerk/SubscriptionPerk';
import * as S from './IntroStage.styled';
export const IntroStage = ({ onNext }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Content, null,
            React.createElement(S.Text, null, "Grow your brand with Fourthwall Pro for $19.00 per month or only $180.00 per year."),
            React.createElement(S.SecondaryText, null, "What\u2019s in it for you?"),
            React.createElement(S.PerksContainer, null,
                React.createElement(SubscriptionPerk, { icon: MoneyIcon }, "$10 per month of sample credit"),
                React.createElement(SubscriptionPerk, { icon: ButtonIcon }, "Free custom domain name"),
                React.createElement(SubscriptionPerk, { icon: TagIcon }, "No fees on digital products"),
                React.createElement(SubscriptionPerk, { icon: ProfileIcon }, "Unlimited team members"),
                React.createElement(SubscriptionPerk, { icon: ApparelIcon }, "Up to 500 products"),
                React.createElement(SubscriptionPerk, { icon: DocumentDownloadIcon }, "Increased files bandwidth"))),
        React.createElement(Button, { label: "Upgrade to Pro", appearance: "primary", fullWidth: true, onClick: onNext })));
};
